@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;

<div id="payment-success" [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    <h2>{{ 'payment_result.success.title' | translate }}</h2>
    <p>{{ 'payment_result.success.message' | translate }}</p>
    <app-button routerLink="/dashboard">{{ 'payment_result.buttons.back_to_dashboard' | translate }}</app-button>
</div>